module.exports = __webpack_public_path__ + "c07e6eeb392ca6208b8f9d63ce6f680c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-11.png
// module id = 1727
// module chunks = 0